<ng-container *ngTemplateOutlet="content">
</ng-container>